import { Link } from "react-router-dom";
import "./nopage.scss";

const NoPage = () => (
  <section className="nopage">
    <div className="nopage__inner">
      <p className="u-mono">Error 404</p>
      <h1 className="nopage__heading">This page doesn't exist</h1>
      <p className="nopage__body">
        The link may be out of date, or the page may have moved. The work is all
        still here.
      </p>
      <div className="nopage__actions">
        <Link className="nopage__cta" to="/">
          Back to home
        </Link>
        <Link className="nopage__cta nopage__cta--ghost" to="/hive">
          See a case study
        </Link>
      </div>
    </div>
  </section>
);

export default NoPage;
